import { vehicleRequestDoors } from './doors';
import { vehicleRequestExecution } from './execution';
import { vehicleRequestLifecycle } from './lifecycle';
import { vehicleRequestLists } from './lists';

/**
 * Ручки заказа техники: заявка на технику или грузоперевозку, назначение машины и машиниста, срок
 * работ, закрытие фактической датой, досрочное завершение, смены, дни линейного заказа, перегоны и
 * бумага, которой заказ сопровождается.
 *
 * Объект один, а собран из четырёх частей — и это не дробление по счётчику строк. Части отвечают
 * на вопрос «по какому порядку с заявкой обращаются»: `lists` только читает и сужается строкой
 * запроса; `lifecycle` правит саму заявку под версией; `doors` ведёт команды, у которых есть
 * предпросмотр, отпечаток показанных последствий и ключ операции; `execution` ведёт то, чем заказ
 * живёт изо дня в день, — рейсы, бумагу, смены и дни. У каждой части своё правило, и в одном файле
 * его пришлось бы повторять у каждой ручки: так и было до разреза, и три пересказа одного
 * инварианта уже разошлись между собой.
 *
 * Спред, а не четыре объекта наружу: адрес `vehicleRequestsApi` знают десятки экранов, и разрез
 * реестра не повод переписывать их все. Имена ручек между частями не пересекаются — спред молча
 * оставил бы от одноимённых последнюю, и пропажа обнаружилась бы не типами, а экраном.
 *
 * Портальные ответы дверей раздаются отсюда же, где лежит объект (описаны они в `commandResults`):
 * публичный вход слайса один, и разведи тип с его ручкой по двум адресам — `index.ts` переписывали
 * бы вслед за каждым внутренним разрезом.
 */
// cache-home: vehicle-requests — every part writes the request or what hangs on it; `route-prefill`
// answers about the routes of a day and is read, not written, through this object.
export const vehicleRequestsApi = {
  ...vehicleRequestLists,
  ...vehicleRequestLifecycle,
  ...vehicleRequestDoors,
  ...vehicleRequestExecution,
};

export type {
  AssignmentCommandResultDto,
  VehicleRequestCompletionResultDto,
  VehicleRequestPeriodResultDto,
} from './commandResults';
